import { render, staticRenderFns } from "./EditorMain.vue?vue&type=template&id=0301a278&scoped=true&"
import script from "./EditorMain.vue?vue&type=script&lang=js&"
export * from "./EditorMain.vue?vue&type=script&lang=js&"
import style0 from "./EditorMain.vue?vue&type=style&index=0&id=0301a278&scoped=true&lang=css&"
import style1 from "./EditorMain.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0301a278",
  null
  
)

export default component.exports